// extracted by mini-css-extract-plugin
export default {"logo":"SignUp_logo__jKvTA","signUpBox":"SignUp_signUpBox__DpUOc","modal":"SignUp_modal__e-UHi"};